module.exports = __webpack_public_path__ + "img/icon_heart_on_brown.78ee6386.svg";